import styled from "styled-components";

export const Wrap = styled.div`
    border: 1px solid #000; 
    width: 360px; 
    padding: 20px;
    margin-bottom: 20px;
`

export const Title = styled.h2`
    margin-bottom: 8px;   
`
export const Text = styled.p`
    margin-bottom: 8px;
`
export const ButtonWrap = styled.div`
    display: flex;
    gap: 8px;   
`
export const Button = styled.button`
    display: inline-block;
    width: 50px;
    height: 50px;
`